import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import Navbardesign from "../Components/Navbar";
import BannerSwiper from "../Components/Bannerdesign/Bannerdesign";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";
import ProjectSection from "../Components/Projectcard/Projectdesign";
import BeforeProjectContent from "../Components/Projectcard/beforProjectContent";

/* ---------------- LAZY LOAD ---------------- */
const Testimonials = lazy(
  () => import("../Components/Testimonalprocess/Testimonalsprocess"),
);

/* ---------------- API BASE ---------------- */
const API_BASE = "https://mithahomes.com/backend/api";
const BLOG_API = `${API_BASE}/blogs/frontend`;
const POPUP_API = `${API_BASE}/popmodelimage/popup-image`;
const VIEW_API = `${API_BASE}/apiviewcount`;
const IMAGE_BASE_URL = "https://mithahomes.com/backend";

const BlogList = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [popupType, setPopupType] = useState(null);
  const [popupBlogId, setPopupBlogId] = useState(null);
  const [popupProjectId, setPopupProjectId] = useState(null);

  /* ---------------- RESPONSIVE STATE ---------------- */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  /* ---------------- VIEW COUNT ---------------- */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    axios.post(`${VIEW_API}/view`).catch(() => { });
  }, []);

  /* ---------------- POPUP LOGIC ---------------- */
  useEffect(() => {
    const initPopup = async () => {
      try {
        // BLOG POPUP FIRST
        const blogRes = await axios.get(BLOG_API);
        if (blogRes.data?.success && blogRes.data.blogs?.length > 0) {
          const blog = blogRes.data.blogs[0];
          if (blog?.image) {
            setPopupImage(`${IMAGE_BASE_URL}${blog.image}`);
            setPopupBlogId(blog.id);
            setPopupType("blog");
            setShowModal(true);
            return;
          }
        }

        // PROJECT POPUP SECOND
        const popupRes = await axios.get(POPUP_API);
        if (popupRes.data?.success && popupRes.data.data?.length > 0) {
          const active = popupRes.data.data.find(
            (i) => Number(i.is_active) === 1,
          );
          if (active?.image) {
            setPopupImage(`${IMAGE_BASE_URL}${active.image}`);
            setPopupProjectId(active.project_id);
            setPopupType("project");
            setShowModal(true);
          }
        }
      } catch (error) {
        console.error("Popup fetch error:", error);
      }
    };

    initPopup();
  }, []);

  const handlePopupClick = () => {
    setShowModal(false);
    if (popupType === "blog") navigate(`/blog/${popupBlogId}`);
    if (popupType === "project") navigate(`/project/${popupProjectId}`);
  };

  return (
    <>
      {/* ---------------- SEO ---------------- */}
      <Helmet>
        <title>Flats for Sale in Trichy | 3 BHK Flats for Sale in Trichy | Mitha Homes</title>
        <meta name="title" content="Flats for Sale in Trichy | 3 BHK Flats for Sale in Trichy | Mitha Homes" />
        <meta
          name="description"
          content="Explore flats for sale in Trichy with Mitha Homes. Discover premium 3 BHK flats for sale in Trichy featuring modern amenities, prime locations, quality construction, and excellent investment value."
        />
        <meta
          name="keywords"
          content="house for sale in trichy, 3 bhk house for sale in trichy,independent house for sale in trichy, new house for sale in trichy"
        />
        <link rel="canonical" href="https://www.mithahomes.com/" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mithahomes.com" />
        <meta
          property="og:title"
          content="3BHK Apartment House & Flats for Sale in Trichy | Mitha Homes"
        />
        <meta
          property="og:description"
          content="Mitha Construction & Development is a trusted and leading construction company in Trichy, delivering high-quality residential and commercial solutions."
        />
        <meta
          property="og:image"
          content="https://mithahomes.com/backend/uploads/OG_banner_image.png"
        />
        <meta property="og:image:alt" content="Mitha Homes - Luxury House for Sale in Trichy" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.mithahomes.com" />
        <meta name="twitter:title" content="House for Sale in Trichy | Mitha Homes" />
        <meta name="twitter:description" content="Discover the best house for sale in Trichy below 3 crore with Mitha Homes. Premium properties and gated communities." />
        <meta name="twitter:image" content="https://mithahomes.com/backend/uploads/OG_banner_image.png" />
      </Helmet>

      {/* ---------------- POPUP MODAL ---------------- */}
      {/* {showModal && popupImage && (
        <div
          style={styles.overlay}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              ...styles.container,
              width: isMobile ? "95%" : isTablet ? "80%" : "auto",
              maxWidth: popupType === "blog" ? "900px" : "500px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={styles.closeBtn}
              onClick={() => setShowModal(false)}
            >
              ×
            </button>

            <img
              src={popupImage}
              alt="Popup"
              onClick={handlePopupClick}
              style={{
                ...styles.image,
                maxHeight: isMobile ? "60vh" : "80vh",
              }}
            />
          </div>
        </div>
      )} */}

      {/* ---------------- PAGE CONTENT ---------------- */}
      <Navbardesign />
      <div style={{ height: isMobile ? "60px" : "90px" }} />

      <BannerSwiper />

      <ProjectSection />

      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>
        }
      >
        <Testimonials />
      </Suspense>

      <Footer />
      <ContactBar />
    </>
  );
};

/* ---------------- STYLES ---------------- */
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(255, 255, 255, 0)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100000,
    backdropFilter: "blur(4px)",
  },

  container: {
    position: "relative",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
    overflow: "hidden",
    animation: "fadeIn 0.3s ease",
  },

  image: {
    width: "100%",
    height: "auto",
    display: "block",
    cursor: "pointer",
    objectFit: "contain",
  },

  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    border: "none",
    background: "#fff",
    color: "#000",
    fontSize: "20px",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
    zIndex: 10,
  },
};

export default BlogList;
